import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { tVE, tVEwithGroupedChildren, tVEwithDetailedResources, tResourceType } from './glowadminservices/glowadmin.typings';
import { GlowAdminService } from './glowadminservices/glowadmin.service';
import { ApplicationSelectorService } from './app-selector.service';
import { tResourceTypeDictionary } from './ui.typings';

@Injectable()
export class ResourceService {
    serviceId: string = 'ResourceService'

    resourceTypeDictionary: tResourceTypeDictionary = {};

    applicationId: string

    private ResourceTypeListAnnouncer = new Subject<tResourceType[]>();

    resourceTypeList$ = this.ResourceTypeListAnnouncer.asObservable()

    constructor(
        private appService: ApplicationSelectorService,
        private glowAdminService: GlowAdminService) {

        var application = JSON.parse(localStorage.getItem('application'));
        if (application) {
            this.applicationId = application.applicationId;
        }

        this.appService.getSelectedApplication.subscribe(application => {
            var application = JSON.parse(localStorage.getItem('application'));
            this.applicationId = application.applicationId;
            console.log(this.serviceId + " Application has been announced, setting applicationId to " + this.applicationId);
        });
    };

    findResourceTypes() {
        if(!this.applicationId) {
            var application = JSON.parse(localStorage.getItem('application'));
            if (application) {
                this.applicationId = application.applicationId;
            }
        } 
        this.glowAdminService
            .getResourceTypes(this.applicationId)
            .subscribe(resourceTypes => {
                this.setResourceTypeDictionary(resourceTypes);
            }, error => {
                console.warn("An error occurred when querying for the resourceTypes");
                console.warn(error)
            });
    };

    setResourceTypeDictionary(resourceTypeList: tResourceType[]) {
        let resourceTypeDictionary = {};
        for (let i = 0; i < resourceTypeList.length; i++) {
            resourceTypeDictionary[resourceTypeList[i].resourceTypeId] = resourceTypeList[i];
        }

        this.resourceTypeDictionary = resourceTypeDictionary
        console.log("resourceTypeDictionary")
        console.log(this.resourceTypeDictionary)
    }

    getResourceTypeDictionary(): tResourceTypeDictionary {
        if (this.resourceTypeDictionary) {
            return this.resourceTypeDictionary
        } else {
            this.findResourceTypes();
            return {}
        }
    }

};